import { Box, Modal } from "@mui/material"
import { DocumentTypeControllerAction, DocumentTypeControllerState } from "../../controller/document.type.controller"
import { DocumentTypeChildrenData } from "../../data/document.type.child";

const DocumentTypeModalView = ({ ctrl }: { ctrl: DocumentTypeControllerState & DocumentTypeControllerAction }) => {

    var model = DocumentTypeChildrenData.filter(
        (item) => ctrl?.activeModal !== null && item.name.includes(ctrl?.activeModal?.name)
    )[0] ?? null;
    return (
        <Modal
            open={ctrl.activeModal != null}
            onClose={() => ctrl.onHandleModal(null)}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
        >
            <Box
                sx={{
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: '900px',
                    borderRadius: '12px',
                    maxHeight: "100%", overflowY: 'auto',
                }}
            >
                <Box>
                    {model != null ? <model.child ctrl={ctrl} /> : null}
                </Box>
            </Box>
        </Modal >
    )
}

export default DocumentTypeModalView;